module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAADhSURBVDiN3ZPBTcNAEEXfX9vSHhLJHcRHuFECVJCUwBFOiAoIFaQEcCmpgHRASshxJcv+XGLJSQARw4m57c78rzejGU0u7p4kLRkRtpeaXt57jLiP8BvxnxjkR+/tJzXVjw0a+yamtEsxlv1fIb2fQ0Ab46qQbo+oNgCGrWAxpDoxMNSS1wDumAmqLKXHNsaFQ9i4aeqQ5299/ckQJZXumPVigBRjifQSuu6hzbLdty1gzzVswX49awYNPOd2PUCa46937cCgkFbYB4iGq0Kq9mbXBZTD/D9Y5WB71CmzP+cPuAhJtGFeQ9UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en.png
// module id = 1wet
// module chunks = 1